import { Product } from 'src/shared/types/product';
import { RFQ } from 'src/shared/types/rfq';

import IncompleteProductsTable from './IncompleteProductsTable';
import ProductsTable from './ProductsTable';

interface SourcingTabContentProps {
  isLoading?: boolean;
  /** Non-archived products, i.e. the ones already submitted for sourcing. */
  products?: Product[];
  isSuccess?: boolean;
  isLoadingIncomplete?: boolean;
  /** Unpublished RFQs, i.e. products the user started but never finished. */
  incompleteProducts?: RFQ[];
  isSuccessIncomplete?: boolean;
}

/**
 * The "Sourcing" tab: submitted products, followed by the products the user
 * never finished. The incomplete section is dropped entirely when there is
 * nothing in it, so users who always finish never see it.
 */
const SourcingTabContent: React.FC<SourcingTabContentProps> = ({
  isLoading,
  products,
  isSuccess,
  isLoadingIncomplete,
  incompleteProducts,
  isSuccessIncomplete
}) => {
  const hasIncompleteProducts = (incompleteProducts?.length ?? 0) > 0;

  return (
    <div className="flex flex-col gap-8">
      <ProductsTable
        isLoading={isLoading}
        products={products}
        isSuccess={isSuccess}
        header="Products"
        headerSingular="Product"
        emptyPlaceholder="Submitted products will appear here"
        showActions
      />

      {hasIncompleteProducts && (
        <IncompleteProductsTable
          isLoading={isLoadingIncomplete}
          products={incompleteProducts}
          isSuccess={isSuccessIncomplete}
        />
      )}
    </div>
  );
};

export default SourcingTabContent;
